import React from 'react';
import type { CodeBlockState } from './CodeBlock';

export type ToolbarProps = {
  state: CodeBlockState;
  editing: boolean;
  cssOpen: boolean;
  copied: boolean;
  searchOpen: boolean;
  onState: (u: (s: CodeBlockState) => CodeBlockState) => void;
  onToggleEdit: () => void;
  onCopy: () => void;
  onToggleCss: () => void;
  onToggleSearch: () => void;
  onOpenCitation: () => void;
};

export function Toolbar({ state, editing, cssOpen, copied, searchOpen, onState, onToggleEdit, onCopy, onToggleCss, onToggleSearch, onOpenCitation }: ToolbarProps) {
  return (
    <div
      className="codeblock-toolbar"
      role="toolbar"
      aria-label={`Code block controls (${state.mode === 'displayCode' ? 'Raw code' : 'Render HTML'})`}
    >
      <div className="left">
        <select
          aria-label="Language"
          value={state.language}
          onChange={(e) => onState((s) => ({ ...s, language: e.target.value as any }))}
        >
          <option value="html">HTML</option>
          <option value="css">CSS</option>
          <option value="javascript">JavaScript</option>
          <option value="json">JSON</option>
          <option value="text">Text</option>
        </select>

        <div className="mode">
          <label>
            <input
              type="radio"
              checked={state.mode === 'displayCode'}
              onChange={() => onState((s) => ({ ...s, mode: 'displayCode' }))}
            />
            Raw code
          </label>
          <label className="html-option">
            <input
              type="radio"
              checked={state.mode === 'renderRich'}
              onChange={() => onState((s) => ({ ...s, mode: 'renderRich' }))}
            />
            <span>Render HTML</span>
          </label>
          <button
            onClick={onToggleSearch}
            aria-label="Search"
            className={`action-btn${searchOpen ? ' active' : ''}`}
          >
            Search
          </button>
        </div>
      </div>

      <div className="actions">
        <button
          onClick={onToggleCss}
          aria-label="Custom CSS"
          className={`action-btn${cssOpen ? ' active' : ''}`}
        >
          CSS
        </button>
        <button
          onClick={onToggleEdit}
          aria-label={editing ? 'Done' : 'Edit'}
          className={`action-btn${editing ? ' active' : ''}`}
        >
          {editing ? 'Done' : 'Edit'}
        </button>
        <button
          onClick={onOpenCitation}
          aria-label="Citation"
          className={`action-btn${state.citation ? ' active' : ''}`}
        >
          Citation
        </button>
        <button
          onClick={onCopy}
          aria-label="Copy"
          className={`action-btn${copied ? ' active' : ''}`}
        >
          Copy
        </button>
      </div>
    </div>
  );
}

export default Toolbar;
